module.exports = __webpack_public_path__ + "img/changying_xl.a3fddcab.png";